exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-results{position:absolute;background:#fff;border:1px solid #dae4e9;max-height:20rem;overflow-y:scroll;z-index:1}.search-results>div{margin-bottom:.5rem;text-align:left}.search-results>div:hover{background-color:#f1f5f8}.search-results>div a{display:block;padding:1rem;font-size:12px}", ""]);

// exports
